/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ImportRequestBuilderNavigationMetadata, ImportRequestBuilderRequestsMetadata, type ImportRequestBuilder } from './importEscaped/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/users/customers
 */
export interface CustomersRequestBuilder extends BaseRequestBuilder<CustomersRequestBuilder> {
    /**
     * The import property
     */
    get importEscaped(): ImportRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const CustomersRequestBuilderUriTemplate = "{+baseurl}/api/organizations/users/customers";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const CustomersRequestBuilderNavigationMetadata: Record<Exclude<keyof CustomersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    importEscaped: {
        requestsMetadata: ImportRequestBuilderRequestsMetadata,
        navigationMetadata: ImportRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
